import * as types from './types';

export const deleteClusterNodeRequest = (data) => ({ type: types.DELETE_CLUSTER_NODE_REQUEST, data });
export const deleteClusterNodeRequestFailure = (error) => ({ type: types.DELETE_CLUSTER_NODE_REQUEST_FAILURE, error });
export const deleteClusterNodeRequestSuccess = (data) => ({ type: types.DELETE_CLUSTER_NODE_REQUEST_SUCCESS, data });

export const getClustersRequest = (data) => ({ type: types.GET_CLUSTERS_REQUEST, data });
export const getClustersRequestFailure = (error) => ({ type: types.GET_CLUSTERS_REQUEST_FAILURE, error });
export const getClustersRequestSuccess = (data) => ({ type: types.GET_CLUSTERS_REQUEST_SUCCESS, data });

export const splitClusterRequest = (data) => ({ type: types.SPLIT_CLUSTER_REQUEST, data });
export const splitClusterRequestFailure = (error) => ({ type: types.SPLIT_CLUSTER_REQUEST_FAILURE, error });
export const splitClusterRequestSuccess = (data) => ({ type: types.SPLIT_CLUSTER_REQUEST_SUCCESS, data });

export const splitClusterAndAssignToEntryRequest = (data) => ({ type: types.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST, data });
export const splitClusterAndAssignToEntryRequestFailure = (error) => ({
  type: types.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_FAILURE,
  error,
});
export const splitClusterAndAssignToEntryRequestSuccess = (data) => ({
  type: types.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_SUCCESS,
  data,
});

export const splitClusterAndOpenClusterAssignModalRequest = (data) => ({
  type: types.SPLIT_CLUSTER_AND_OPEN_CLUSTER_ASSIGN_MODAL_REQUEST,
  data,
});

export const updateClusterRequest = (data) => ({ type: types.UPDATE_CLUSTER_REQUEST, data });
export const updateClusterRequestFailure = (error) => ({ type: types.UPDATE_CLUSTER_REQUEST_FAILURE, error });
export const updateClusterRequestSuccess = (data) => ({ type: types.UPDATE_CLUSTER_REQUEST_SUCCESS, data });

export const updateClusterNodeRequest = (data) => ({ type: types.UPDATE_CLUSTER_NODE_REQUEST, data });
export const updateClusterNodeRequestFailure = (error) => ({ type: types.UPDATE_CLUSTER_NODE_REQUEST_FAILURE, error });
export const updateClusterNodeRequestSuccess = (data) => ({ type: types.UPDATE_CLUSTER_NODE_REQUEST_SUCCESS, data });

export const updateClusterOverlapsRequest = (data) => ({ type: types.UPDATE_CLUSTER_OVERLAPS_REQUEST, data });
export const updateClusterOverlapsRequestFailure = (error) => ({ type: types.UPDATE_CLUSTER_OVERLAPS_REQUEST_FAILURE, error });
export const updateClusterOverlapsRequestSuccess = (data) => ({ type: types.UPDATE_CLUSTER_OVERLAPS_REQUEST_SUCCESS, data });
